import { InfoCircleIcon } from '../icons/new'

const Tooltip = ({ text }) => {
    return (
        <div className="tooltip tooltip-normal tw:!inline-flex p-0 ms-1">
            <InfoCircleIcon className="text-gray-200" />
            <span className="tooltiptext tooltiptext-big">{text}</span>
        </div>
    )
}

export default Tooltip
